import type { CoinFountainTuning, FountainEmission } from "../views/coin-fountain/CoinFountainTuning";

/** The big win's coin fountain: the fountain itself, how hard it runs per tier, how it leaves with the panel. */
interface BigWinCoinFountainTuning {
  readonly fountain: CoinFountainTuning;
  /**
   * How hard it runs once a tier's title is revealed, by tier id (the server's `levelIdentifier`): the first titled
   * reveal starts it and every tier after it steps it up. A tier with no entry (nice, which has no title) starts nothing.
   */
  readonly emissionByTier: Readonly<Partial<Record<string, FountainEmission>>>;
  /** The coins in flight fade out over the panel's exit (its tier `out` clip runs 0.4 s). */
  readonly exitFadeSeconds: number;
}

/**
 * Per-game BIG-WIN COIN FOUNTAIN values — the ONLY file to edit to retune it (BigWinView reads them). Coins are thrown
 * from behind the tier title, up and out to the top and the sides, and fall out of the screen; they keep coming
 * through "tap to continue" and fade with the exit. Chrome-runner seconds (never speed-scaled, frozen by the dev
 * pause); lengths in design units unless a field says the title's (the panel content's units).
 */
export const COIN_FOUNTAIN_TUNING: BigWinCoinFountainTuning = {
  fountain: {
    maxCoins: 64,
    gravity: 2600,
    // Most of the title art (about 1000 × 800 in the content's units): a burst comes out from behind all of it, and
    // every coin starts hidden.
    spawnHalfSize: { width: 300, height: 150 },
    apexHeight: { min: 0.45, max: 0.95 },
    sideReach: { min: 0.08, max: 1.2 },
    cullMargin: 240,
    coin: {
      // The coin art is 280 × 294; in the title's units, so the coins keep their size against it on every shape.
      scale: { min: 0.45, max: 0.85 },
      // Its clip is one half-turn in 0.333 s.
      spinRate: { min: 0.6, max: 1.3 },
      tiltDegrees: 25,
      turnDegreesPerSecond: 90,
    },
  },
  emissionByTier: {
    big: { burst: 14, ratePerSecond: 10, heightScale: 0.8 },
    huge: { burst: 20, ratePerSecond: 16, heightScale: 0.9 },
    epic: { burst: 28, ratePerSecond: 24, heightScale: 1 },
  },
  exitFadeSeconds: 0.4,
};
